import _extends from '../../../../node_modules/@babel/runtime/helpers/esm/extends.js';
import _defineProperty from '../../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import _objectWithoutProperties from '../../../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import PropTypes__default from 'prop-types';
import React__default from 'react';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

var _excluded = ["children", "color", "variant", "disabled", "white", "edge", "disableFocusRipple", "disableRipple", "onClick", "onBlur", "onFocus", "size", "className"];
var useStyles = makeStyles(function (theme) {
  return {
    contained: {},
    outlined: {
      background: theme.palette.grey["0"] + "!important",
      border: "1px solid" + theme.palette.secondary["200"],
      "&:hover": {
        background: "rgba(112, 194, 118, 0.08)" + "!important",
        border: "1px solid" + theme.palette.secondary["200"],
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.14)",
        borderRadius: theme.spacing(3)
      },
      "& i": {
        fontSize: "16px ",
        color: theme.palette.primary[700]
      }
    },
    white: {
      background: theme.palette.grey["0"] + " !important",
      "&:hover": {
        background: "rgba(112, 194, 118, 0.08)" + "!important",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.14)",
        borderRadius: theme.spacing(3)
      },
      border: "none !important",
      "& i": {
        fontSize: "16px ",
        color: theme.palette.text.black + " !important"
      }
    },
    blackText: {
      "&:hover": {
        border: "1px solid" + theme.palette.secondary["200"],
        backgroundColor: "rgba(0, 0, 0, 0.08)" + "!important"
      },
      "& i": {
        color: theme.palette.text.black
      }
    },
    colorPrimary: {
      background: theme.palette.primary["200"] + "!important",
      "&:hover": {
        background: theme.palette.primary["200"] + "!important",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.14) !important",
        borderRadius: theme.spacing(3)
      },
      "& i": {
        fontSize: "16px ",
        color: theme.palette.grey["500"]
      },
      "&:disabled i": {
        color: theme.palette.grey["200"]
      }
    },
    colorSecondary: {
      background: theme.palette.secondary.main + "!important",
      "&:hover": {
        background: theme.palette.secondary["900"] + "!important",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.14) !important",
        borderRadius: "24px"
      },
      "& i": {
        fontSize: "16px ",
        color: theme.palette.grey["0"]
      },
      "&:disabled i": {
        color: theme.palette.grey["200"]
      }
    },
    negative: {
      border: "1px solid " + theme.palette.grey[0],
      color: theme.palette.grey[0] + " !important",
      "&:hover": {
        background: "rgba(255, 255, 255, 0.08)" + "!important",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.14)",
        borderRadius: theme.spacing(5)
      },
      "& i": {
        fontSize: "16px ",
        color: theme.palette.grey[0] + " !important"
      }
    },
    disabled: {
      background: theme.palette.grey["100"] + " !important",
      borderRadius: "57px",
      border: "none !important",
      "&:hover": {
        background: theme.palette.grey["100"] + " !important",
        boxShadow: "none !important"
      },
      "& i": {
        fontSize: "16px ",
        color: theme.palette.grey["300"] + " !important"
      }
    }
  };
});
var CustomIconButton = function CustomIconButton(_ref) {
  var children = _ref.children,
    color = _ref.color,
    variant = _ref.variant,
    disabled = _ref.disabled,
    white = _ref.white,
    edge = _ref.edge,
    disableFocusRipple = _ref.disableFocusRipple,
    disableRipple = _ref.disableRipple,
    onClick = _ref.onClick,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    size = _ref.size,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var handleClick = function handleClick() {
    if (onClick) {
      onClick();
    }
  };
  var handleFocus = function handleFocus() {
    if (onFocus) {
      onFocus();
    }
  };
  var handleBlur = function handleBlur() {
    if (onBlur) {
      onBlur();
    }
  };
  return /*#__PURE__*/React__default.createElement(IconButton, _extends({}, props, {
    className: clsx(className, _defineProperty({}, classes.disabled, disabled), _defineProperty({}, classes.contained, variant === "contained"), _defineProperty({}, classes.outlined, variant === "outlined"), _defineProperty({}, classes.white, white === true), _defineProperty({}, classes.blackText, color === "black"), _defineProperty({}, classes.colorPrimary, color === "primary"), _defineProperty({}, classes.colorSecondary, color === "secondary"), _defineProperty({}, classes.negative, color === "negative"), _defineProperty({}, classes.disabled, disabled)),
    color: color !== "black" && color !== "negative" ? color : "default",
    disabled: disabled,
    edge: edge,
    disableFocusRipple: disableFocusRipple,
    disableRipple: disableRipple,
    size: size,
    onClick: handleClick,
    onBlur: handleBlur,
    onFocus: handleFocus
  }), children);
};
CustomIconButton.defaultProps = {
  color: "default",
  disabled: false,
  white: false
};
CustomIconButton.propTypes = {
  children: PropTypes__default.element.isRequired,
  color: PropTypes__default.string,
  variant: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  white: PropTypes__default.bool,
  edge: PropTypes__default.string,
  disableFocusRipple: PropTypes__default.bool,
  disableRipple: PropTypes__default.bool,
  size: PropTypes__default.string,
  onClick: PropTypes__default.func,
  className: PropTypes__default.string,
  onBlur: PropTypes__default.func,
  onFocus: PropTypes__default.func
};

export { CustomIconButton as default };
//# sourceMappingURL=CustomIconButton.js.map
